import './App.css';
import MapList from "./components/MapList";
import 'bootstrap/dist/css/bootstrap.min.css';
import {maps} from "./config/maps";

function App() {
  
  return (
    <MapList mapList={maps}/>
  );
}

export default App;
